"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiTermMetadataTypeEnum;
(function (TableauNlpRefinementuiTermMetadataTypeEnum) {
    TableauNlpRefinementuiTermMetadataTypeEnum["None"] = "None";
    TableauNlpRefinementuiTermMetadataTypeEnum["Sort"] = "Sort";
    TableauNlpRefinementuiTermMetadataTypeEnum["Limit"] = "Limit";
    TableauNlpRefinementuiTermMetadataTypeEnum["Field"] = "Field";
    TableauNlpRefinementuiTermMetadataTypeEnum["DateFilter"] = "DateFilter";
    TableauNlpRefinementuiTermMetadataTypeEnum["RelativeDateFilter"] = "RelativeDateFilter";
    TableauNlpRefinementuiTermMetadataTypeEnum["RangeDateFilter"] = "RangeDateFilter";
    TableauNlpRefinementuiTermMetadataTypeEnum["IndividualDateFilter"] = "IndividualDateFilter";
    TableauNlpRefinementuiTermMetadataTypeEnum["QuantitativeFilter"] = "QuantitativeFilter";
    TableauNlpRefinementuiTermMetadataTypeEnum["CategoricalFilter"] = "CategoricalFilter";
    TableauNlpRefinementuiTermMetadataTypeEnum["VizType"] = "VizType";
    TableauNlpRefinementuiTermMetadataTypeEnum["TableCalc"] = "TableCalc";
    TableauNlpRefinementuiTermMetadataTypeEnum["KeepOnlyOrExcludeFilter"] = "KeepOnlyOrExcludeFilter";
})(TableauNlpRefinementuiTermMetadataTypeEnum = exports.TableauNlpRefinementuiTermMetadataTypeEnum || (exports.TableauNlpRefinementuiTermMetadataTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiTermMetadataDiscourseTypeEnum;
(function (TableauNlpRefinementuiTermMetadataDiscourseTypeEnum) {
    TableauNlpRefinementuiTermMetadataDiscourseTypeEnum["Empty"] = "Empty";
    TableauNlpRefinementuiTermMetadataDiscourseTypeEnum["Remove"] = "Remove";
    TableauNlpRefinementuiTermMetadataDiscourseTypeEnum["ReplaceAdd"] = "ReplaceAdd";
    TableauNlpRefinementuiTermMetadataDiscourseTypeEnum["ReplaceRemove"] = "ReplaceRemove";
})(TableauNlpRefinementuiTermMetadataDiscourseTypeEnum = exports.TableauNlpRefinementuiTermMetadataDiscourseTypeEnum || (exports.TableauNlpRefinementuiTermMetadataDiscourseTypeEnum = {}));
function TableauNlpRefinementuiTermMetadataFromJSON(json) {
    return TableauNlpRefinementuiTermMetadataFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiTermMetadataFromJSON = TableauNlpRefinementuiTermMetadataFromJSON;
function TableauNlpRefinementuiTermMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': !runtime_1.exists(json, 'index') ? undefined : json['index'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'isPunctuation': !runtime_1.exists(json, 'isPunctuation') ? undefined : json['isPunctuation'],
        'isDiscourseMarker': !runtime_1.exists(json, 'is_discourse_marker') ? undefined : json['is_discourse_marker'],
        'discourseType': !runtime_1.exists(json, 'discourse_type') ? undefined : json['discourse_type'],
        'isHidden': !runtime_1.exists(json, 'is_hidden') ? undefined : json['is_hidden'],
        'inPlayIndex': !runtime_1.exists(json, 'in_play_index') ? undefined : json['in_play_index'],
    };
}
exports.TableauNlpRefinementuiTermMetadataFromJSONTyped = TableauNlpRefinementuiTermMetadataFromJSONTyped;
function TableauNlpRefinementuiTermMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'type': value.type,
        'isPunctuation': value.isPunctuation,
        'is_discourse_marker': value.isDiscourseMarker,
        'discourse_type': value.discourseType,
        'is_hidden': value.isHidden,
        'in_play_index': value.inPlayIndex,
    };
}
exports.TableauNlpRefinementuiTermMetadataToJSON = TableauNlpRefinementuiTermMetadataToJSON;
